import React from "react";
import { Link } from "react-router-dom";
import "../../css/PrePrimarySection.css";
import SchoolHero from "./SchoolHero";
import ParentTestimonials from "../ParentTestimonials";
import WhyChooseUs from "../WhyChooseUs";

const PrePrimarySection = () => {

  const kidsImg = "/images/e.jpeg";

  return (
    <>
      <SchoolHero
        title="PrePrimary School"
        subtitle="Building strong foundations for lifelong learning."
        image="/images/e.jpeg"
      />

      <section className="pre-primary-container">

        <div className="pre-primary-card">

          <div className="pre-primary-flex">

            <div className="pp-image-side">
              <img
                src={kidsImg}
                alt="Pre Primary Kids"
                className="pp-classroom-img"
              />
            </div>


            <div className="pp-content-side">

              <div className="pp-dark-header">
                <h2>Pre-Primary (N.-K2)</h2>
              </div>


              <div className="pp-content-body">

                <div className="pp-meta">

                  <span>
                    <strong>Grade Pre KG-K2</strong>
                  </span>

                  <span className="pp-status">
                    <i>✔</i> Enrolling Now
                  </span>

                </div>


                <p className="pp-text">

                  We recognise that every child is unique and a highly-valued
                  member of our school community. We understand the importance
                  of new-age learning and holistic development during a child's
                  formative years.

                  <br/><br/>

                  Our{" "}
                  <span className="pp-highlight">
                    pre-primary programme
                  </span>{" "}
                  focuses on building skills and exploring talents through
                  age-appropriate activities in a safe and nurturing
                  environment.

                  By encouraging children's natural curiosity, we begin to set
                  the stage for lifelong learning.

                </p>

              </div>


              <div className="pp-bottom-nav">

                <div>
                  <Link to="/book-meeting">
                    🤝 BOOK A MEETING
                  </Link>
                </div>

                <div>
                  <Link to="/admissionenquiryform">
                    📄 ADMISSION FORM
                  </Link>
                </div>

                <div>
                  <Link to="/feestructure">
                    💵 FEES
                  </Link>
                </div>

              </div>


            </div>

          </div>

        </div>

      </section>


      <ParentTestimonials />

      <WhyChooseUs />

    </>
  );
};

export default PrePrimarySection;